import { get } from "lodash";

// An account the user can proxy as (proxied account), from GET /api/account-proxy/access. `id`(account_id) is the
// value the X-PROXY-TARGET-ACCOUNT header carries (the grant API uses emails instead).

// Reads the proxyable accounts off the /access response. Empty means the user can't
// proxy (no live grants). Already filtered to live grants server-side.
export var getProxyAccounts = function getProxyAccounts(access) {
  return get(access, ["proxy_target_accounts"], []);
};